import GradePage from "@/pages/GradePage";
export default function GradeCalculus() {
  return <GradePage grade="C" />;
}
